import type {Suggest} from '@yandex-delivery/api/model/suggest'
import type {AddressSuggestParams as SuggestRequest} from '@yandex-delivery/api/service/suggest/type'
import {
  constant,
  flow,
  get,
  head,
  identity,
  ifElse,
  isEmpty,
  pipe,
} from '@yandex-delivery/utils'

import {DEFAULT_CITIES} from '../../../../consts'
import type {LocationDetectedVariant} from '../../../../types'
import type {
  LocationRequest,
  LocationResponse,
} from '../../../deprecated/fetch-detect-location-by-city'
import type {GeoID, PickupPointCity} from '../../../models/pickup-route'

export function toDetectCityRequest(request: SuggestRequest) {
  return function _toDetectCityRequest(suggest: Suggest): LocationRequest {
    return pipe(
      suggest,
      get('__origin'),
      get('results.[0].city'),
      (text?: string): LocationRequest => ({
        text,
        type: 'a',
        location: request.location,
      }),
    )
  }
}

function toPickupPointCity(
  locationVariant?: LocationDetectedVariant,
): PickupPointCity {
  return locationVariant
    ? {
        id: locationVariant.geo_id as GeoID,
        name: locationVariant.address,
      }
    : {
        id: -1 as GeoID,
        name: 'Unknown city',
      }
}

export const toCity: (response: LocationResponse) => PickupPointCity = //
  flow(
    get('__origin'),
    ifElse(isEmpty, constant(DEFAULT_CITIES), identity),
    head as (xs: LocationDetectedVariant[]) => LocationDetectedVariant,
    toPickupPointCity,
  )
